"use client";
import {useState} from "react";
import React from "react";
import Slider from "react-slick";
import Image from "next/image";
import Link from "next/link";
import SectionTitleIcon from "@/app/components/common/SectionTitleIcon";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "@/app/styles/components/pages/partners/partner-our-partners-section.module.scss";
import {getCDNImage} from "@/app/utils/ImageUtil";

function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  const [isHovered, setIsHovered] = useState(false);
  return (
    <Image
      src={isHovered ? '/slider-pink-right-arrow.png' : '/slider-white-right-arrow.png'}
      alt="strelica"
      width={60}
      height={60}
      className={`arrowSlider ${styles.nextArrow}`}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  const [isHovered, setIsHovered] = useState(false);
    return (
       <Image
        src={isHovered ? '/slider-pink-left-arrow.png' : '/slider-white-left-arrow.png'}
        alt="strelica"
        width={60}
        height={60}
        className={`arrowSlider ${styles.prevArrow}`}
        onClick={onClick}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
    />
  );
}

const PartnerOurPartnersSection = ({ data }) => {

   const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 4,
      slidesToScroll: 1,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
        responsive: [
          {
            breakpoint: 360,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 992,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1220,
            settings: {
              slidesToShow: 4,
            }
          }
        ]
    };

  return (
    <>
      <div className={styles.mainContainer}>
        <div className="container">
          <div className={styles.titleTextContainer}>
            <SectionTitleIcon title={data.our_partners_title} icon={data.our_partners_icon}/>
            <p className={styles.text}>{data.our_partners_text}</p>
          </div>
          <div className={styles.imagesSlider}>
            <Slider {...settings}>
              {data.our_partners_repeater.map((item) => (
                <div className="sliderItem" key={'partner-repeater-' + item.partner.ID}>
                  <Link href={`/nasi-partneri/${item.partner.post_name}`}>
                    <div
                        className={styles.image}
                        style={{
                      backgroundImage: `url(${getCDNImage(item.image)})`,
                      backgroundSize: "cover",
                      backgroundRepeat: "no-repeat",
                      backgroundPositionX: "center",
                      backgroundPositionY: "center",
                    }}>
                    </div>
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </>
  );
};

export default PartnerOurPartnersSection;
